import React from "react";
import cn from "classnames";

import { Divider } from "components/Spacing";

import styles from "./styles.module.scss";

/**
 * Единый шаблон экрана: белая карточка с header / body / footer.
 * Почти все экраны приложения строятся из него.
 */
export const PageLayout = ({
  header,
  footer,
  children,
  className,
  width,
  height,
  bodyClassName,
  bodyFill,
}) => (
  <div className={cn(styles.root, className)} style={{ width, height }}>
    {!!header && (
      <>
        <div className={styles.header}>{header}</div>
        <Divider />
      </>
    )}
    <div
      className={cn(styles.body, bodyFill && styles.bodyFill, bodyClassName)}
    >
      {children}
    </div>
    {!!footer && (
      <>
        <Divider />
        <div className={styles.footer}>{footer}</div>
      </>
    )}
  </div>
);

/** Панель действий (ряд кнопок) — используется в футерах и тулбарах */
export const ActionsRow = ({ children, className }) => (
  <div className={cn(styles.actionsRow, className)}>{children}</div>
);
